import BaseModel from '../../base';

import constants, { LIMITS } from './constants';
import glossary from './glossary';

export default class AssociationCardNumberPool extends BaseModel {
  constructor(item = {}, url) {
    super(item, url);

    this.range_start = item.range_start || LIMITS.min;
    this.range_end = item.range_end || LIMITS.max;
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
